<template>
  <div class="contents" v-loading="loading">
    <div class="title flexB">
      <h2>레벨 테스트 출제 설정</h2>
    </div>

    <Navigation />

    <div class="box one">
      <p class="mb20">
        레벨별로 한 세션당 출제할 문항 수를 설정합니다. 앱은 이 설정을 기준으로
        서버에서 랜덤 출제합니다.
      </p>

      <table>
        <colgroup>
          <col style="width: 20%" />
          <col style="width: 20%" />
          <col style="width: 20%" />
          <col style="width: 20%" />
          <col style="width: 20%" />
        </colgroup>
        <tr>
          <th>레벨</th>
          <th>단답형</th>
          <th>단어/문장</th>
          <th>말하기/듣기</th>
          <th>활성</th>
        </tr>
        <tr v-for="row in rows" :key="row.level">
          <td>{{ getLevelLabel(row.level) }}</td>
          <td><el-input-number v-model="row.short_answer" :min="0" /></td>
          <td><el-input-number v-model="row.word_sentence" :min="0" /></td>
          <td><el-input-number v-model="row.speaking_listen" :min="0" /></td>
          <td><el-switch v-model="row.active" /></td>
        </tr>
      </table>

      <div class="buttonWrap">
        <button class="basic" @click="submit">설정 저장</button>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchLevelTestConfig, updateLevelTestConfig } from "@/api/admin";
import { getLevelLabel, LEVEL_TEST_LEVELS } from "@/config/levelTest";
import Navigation from "./Navigation.vue";

function createDefaultRow(level) {
  return {
    level,
    short_answer: 4,
    word_sentence: 4,
    speaking_listen: 2,
    active: true,
  };
}

export default {
  name: "levelTestConfig",
  components: {
    Navigation,
  },
  data() {
    return {
      loading: false,
      rows: LEVEL_TEST_LEVELS.map((item) => createDefaultRow(item.value)),
    };
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "6");
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    getLevelLabel,
    getConfig() {
      this.loading = true;
      fetchLevelTestConfig()
        .then((res) => {
          if (res.data.status === 200 && Array.isArray(res.data.data)) {
            const fetched = res.data.data;
            this.rows = LEVEL_TEST_LEVELS.map((item) => {
              const matched = fetched.find(
                (config) => config.level === item.value
              );
              if (!matched) {
                return createDefaultRow(item.value);
              }
              return {
                level: matched.level,
                short_answer: matched.counts?.short_answer || 0,
                word_sentence: matched.counts?.word_sentence || 0,
                speaking_listen: matched.counts?.speaking_listen || 0,
                active: matched.active !== false,
              };
            });
          } else if (res.data.status !== 200) {
            alert(res.data.message || "출제 설정을 불러오지 못했습니다.");
          }
        })
        .catch((err) => {
          alert(err.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit() {
      const configs = this.rows.map((row) => ({
        level: row.level,
        active: row.active !== false,
        counts: {
          short_answer: Number(row.short_answer || 0),
          word_sentence: Number(row.word_sentence || 0),
          speaking_listen: Number(row.speaking_listen || 0),
        },
      }));

      updateLevelTestConfig({ configs }).then((res) => {
        if (res.data.status === 200) {
          alert("출제 설정이 저장 되었습니다.");
          this.getConfig();
        } else {
          alert(res.data.message || "설정 저장에 실패했습니다.");
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.levelTestNav {
  margin: 80px 10px 30px 30px;
}
</style>
